import { useEmployee } from "@/contexts/EmployeeProvider.tsx";
import { useAuth0 } from "@auth0/auth0-react";
import { Divider, ListItem, ListItemText, Menu, MenuItem } from "@mui/material";
import { type PopupState, bindMenu } from "material-ui-popup-state/hooks";
import type { ReactNode } from "react";

type Props = {
    state: PopupState;
};

const UserMenu = ({ state }: Props): ReactNode => {
    const { logout } = useAuth0();
    const { employee } = useEmployee();

    return (
        <Menu
            {...bindMenu(state)}
            slotProps={{
                paper: { sx: { maxWidth: 400 } },
            }}
        >
            {employee && (
                <ListItem>
                    <ListItemText
                        primaryTypographyProps={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                        }}
                        secondaryTypographyProps={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                        }}
                        primary={employee.fullName}
                        secondary={employee.eMailAddress}
                    />
                </ListItem>
            )}
            <Divider key="divider" sx={{ mb: 1 }} />
            <MenuItem
                onClick={() => {
                    state.close();
                    void logout({
                        logoutParams: {
                            returnTo: window.origin,
                        },
                    });
                }}
            >
                Log out
            </MenuItem>
        </Menu>
    );
};

export default UserMenu;
